module.exports = __webpack_public_path__ + "static/media/Group_812.0ecb4b39.svg";